/*
 * PROD-7828 R10 — calculation-rules page: response shaping and error routing. Pure. Values and units
 * are shown as the policy table stores them; the page never reinterprets a rule (e.g. "0.50" pct).
 */
import { EM_DASH, api_error, is_permission_error } from '../format';

// reports_enums.json rules.notice; shown when a response carries none, so the page never looks editable.
export const RULES_NOTICE =
  'Read-only. These values change only through a reviewed engineering change, never from this page.';

const text = (v) => (v === null || v === undefined || v === '' ? EM_DASH : String(v));

const rule_view = (r) => ({
  policy_key: r.policy_key,
  value: text(r.value),
  unit: text(r.unit),
  description: r.description || '',
  prd_ref: text(r.prd_ref),
  decision_ref: text(r.decision_ref),
  effective_from: text(r.effective_from),
  updated_by: text(r.updated_by)
});

// Groups arrive in the server's order (GroupRules); an empty group is not shown.
export const rules_view = (data) => {
  const d = data || {};
  const groups = (Array.isArray(d.groups) ? d.groups : [])
    .map((g) => ({
      key: g.key,
      label: g.label || g.key,
      rows: (Array.isArray(g.rows) ? g.rows : []).map(rule_view)
    }))
    .filter((g) => g.rows.length);
  return { notice: d.notice || RULES_NOTICE, groups };
};

// The two codes GET /policy/rules can return: FORBIDDEN -> the shell's no-permission page.
export const RULES_ERROR_TEXT = {
  LOOKUP_FAILED: 'Could not load the calculation rules. Try again.'
};

export const rules_error_view = (e, fallback) => {
  const { code, message } = api_error(e);
  if (is_permission_error(e) || code === 'FORBIDDEN') return { kind: 'permission', code };
  return { kind: 'inline', code, text: message || RULES_ERROR_TEXT[code] || fallback };
};
